<template>
  <div :style="`width: ${width}px; height: ${height}px;`">
    <svg
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="`top: ${topPosition}px; position: relative;`"
    >
      <path
        d="M7.0002 7.66686C7.21131 7.66686 7.39175 7.59464 7.54153 7.4502C7.69175 7.30575 7.76686 7.12797 7.76686 6.91686V4.31686C7.76686 4.10575 7.69175 3.93086 7.54153 3.7922C7.39175 3.65308 7.21131 3.58353 7.0002 3.58353C6.78908 3.58353 6.60864 3.65575 6.45886 3.8002C6.30864 3.94464 6.23353 4.12242 6.23353 4.33353V6.93353C6.23353 7.14464 6.30864 7.31975 6.45886 7.45886C6.60864 7.59753 6.78908 7.66686 7.0002 7.66686ZM7.0002 10.4669C7.22242 10.4669 7.40864 10.3918 7.55886 10.2415C7.70864 10.0918 7.78353 9.90575 7.78353 9.68353C7.78353 9.46131 7.70864 9.27531 7.55886 9.12553C7.40864 8.97531 7.22242 8.9002 7.0002 8.9002C6.77797 8.9002 6.59197 8.97531 6.4422 9.12553C6.29197 9.27531 6.21686 9.46131 6.21686 9.68353C6.21686 9.90575 6.29197 10.0918 6.4422 10.2415C6.59197 10.3918 6.77797 10.4669 7.0002 10.4669ZM7.0002 13.8002C6.05575 13.8002 5.16953 13.6224 4.34153 13.2669C3.51397 12.9113 2.79464 12.428 2.18353 11.8169C1.57242 11.2058 1.08908 10.4864 0.733529 9.65886C0.377973 8.83086 0.200195 7.94464 0.200195 7.0002C0.200195 6.05575 0.377973 5.16953 0.733529 4.34153C1.08908 3.51397 1.57242 2.79464 2.18353 2.18353C2.79464 1.57242 3.51397 1.08908 4.34153 0.733529C5.16953 0.377973 6.05575 0.200195 7.0002 0.200195C7.94464 0.200195 8.83086 0.377973 9.65886 0.733529C10.4864 1.08908 11.2058 1.57242 11.8169 2.18353C12.428 2.79464 12.9113 3.51397 13.2669 4.34153C13.6224 5.16953 13.8002 6.05575 13.8002 7.0002C13.8002 7.94464 13.6224 8.83086 13.2669 9.65886C12.9113 10.4864 12.428 11.2058 11.8169 11.8169C11.2058 12.428 10.4864 12.9113 9.65886 13.2669C8.83086 13.6224 7.94464 13.8002 7.0002 13.8002ZM7.0002 12.2835C8.46686 12.2835 9.7142 11.7698 10.7422 10.7422C11.7698 9.7142 12.2835 8.46686 12.2835 7.0002C12.2835 5.53353 11.7698 4.2862 10.7422 3.2582C9.7142 2.23064 8.46686 1.71686 7.0002 1.71686C5.53353 1.71686 4.28642 2.23064 3.25886 3.2582C2.23086 4.2862 1.71686 5.53353 1.71686 7.0002C1.71686 8.46686 2.23086 9.7142 3.25886 10.7422C4.28642 11.7698 5.53353 12.2835 7.0002 12.2835Z"
        :fill="color"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ExclamationAlertIcon',
  props: {
    color: {
      type: String,
      default: '#ff585d',
    },
    topPosition: {
      type: String,
      default: '2',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '14',
    },
  },
}
</script>
